export const en = {
  save: 'save',
  delete: 'delete',
  cancel: 'cancel',
  edit: 'edit',
  new: 'new',
  previous: 'previous',
  next: 'next',
  show: 'show',
  to: 'to',
  from: 'from',
  results: 'results',
  hide: 'hide',
  filters: 'filters',
  filter: 'filter',
  'select-option': 'select option',
  'remove-selection': 'remove selection',
  'delete-this': 'delete this',
  'delete-confirm': 'are you sure you want to delete this item?',
  'upload-file': 'upload a file',
  'upload-another-file': 'upload another file',
  'up-to': 'up to',
  'select-one': 'select one',
}
